import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { WidgetProps } from '../../types/WidgetProps';

export const ALL_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.ApplePay,
  PaymentMethod.PayPal,
  PaymentMethod.PayPalCredit,
  PaymentMethod.PayPalPayLater,
  PaymentMethod.Venmo,
  PaymentMethod.GooglePay,
];

export const defaultProps: Partial<WidgetProps> = {
  locale: 'en',
  theme: 'dark',
  layout: 'vertical',
  buttonStyle: {
    shape: 'rect',
    height: 42,
  },
  allowPaymentMethods: ALL_PAYMENT_METHODS,
};

export const requiredProps: (keyof WidgetProps)[] = [
  'paymentAmount',
  'paymentLabel',
  'currency',
  'domain',
  'meta',
  'onPaymentAuthorized',
];
